if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupSwipeNavigation();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      setupSwipeNavigation() {
        const container = this.querySelector('[role="document"]');
        if (!container || container._swipeSetup) return;
        container._swipeSetup = true;

        // Add arrow buttons
        if (!this.querySelector('.modal-nav-btn')) {
          const prevBtn = document.createElement('button');
          prevBtn.className = 'modal-nav-btn modal-nav-prev';
          prevBtn.innerHTML = '&#8249;';
          prevBtn.setAttribute('aria-label', 'Previous image');

          const nextBtn = document.createElement('button');
          nextBtn.className = 'modal-nav-btn modal-nav-next';
          nextBtn.innerHTML = '&#8250;';
          nextBtn.setAttribute('aria-label', 'Next image');

          this.appendChild(prevBtn);
          this.appendChild(nextBtn);

          prevBtn.addEventListener('click', () => this.navigateMedia(-1));
          nextBtn.addEventListener('click', () => this.navigateMedia(1));
        }

        // Swipe detection
        let startX = 0;
        container.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
        }, { passive: true });

        container.addEventListener('touchend', (e) => {
          const diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            this.navigateMedia(diff > 0 ? 1 : -1);
          }
        }, { passive: true });
      }

      navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeMedia = this.querySelector('[data-media-id].active');
        const currentIndex = allMedia.indexOf(activeMedia);
        const nextIndex = (currentIndex + direction + allMedia.length) % allMedia.length;
        const nextMedia = allMedia[nextIndex];

        allMedia.forEach(el => el.classList.remove('active'));
        nextMedia.classList.add('active');
        nextMedia.scrollIntoView({ behavior: 'smooth' });
      }
    }
  );
}